<template>
    <v-container>
      <v-row>
        <v-col cols="12">
          <h1>403 - Unauthorized</h1>
        </v-col>
      </v-row>
    </v-container>
</template>